import "./App.css";
import Flags from "./Flags";
function App() {
  return (
    <>
      <Flags />
    </>
  );
}

export default App;
